import { render, staticRenderFns } from "./treasureContractRentPanelMulti.vue?vue&type=template&id=37ba6974&scoped=true&"
import script from "./treasureContractRentPanelMulti.vue?vue&type=script&lang=js&"
export * from "./treasureContractRentPanelMulti.vue?vue&type=script&lang=js&"
import style0 from "./treasureContractRentPanelMulti.vue?vue&type=style&index=0&id=37ba6974&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37ba6974",
  null
  
)

export default component.exports